export const eur = (n, dec = 0) =>
  new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: dec,
    maximumFractionDigits: dec,
  }).format(Number.isFinite(n) ? n : 0);

export const pct = (n, dec = 2) =>
  `${(Number.isFinite(n) ? n : 0).toLocaleString("es-ES", {
    minimumFractionDigits: dec,
    maximumFractionDigits: dec,
  })} %`;

export const num = (n) => new Intl.NumberFormat("es-ES").format(Math.round(n));
